import { Ajaxinate } from 'ajaxinate';

class ProductGrid extends HTMLElement {
  // Define a map to store the mapping between paginationType attribute values and their corresponding method values
  static paginationTypes = new Map([
    ['infinite-click', 'click'],
    ['infinite-load', 'scroll'],
  ]);

  static get observedAttributes() {
    return ['pagination-type'];
  }

  constructor() {
    super();

    // Bind the initPagination method to the ProductGrid instance
    this.initPagination = this.initPagination.bind(this);
  }

  connectedCallback() {
    this.paginationType = this.getAttribute('pagination-type');

    // Get the method value for the given paginationType
    const method = ProductGrid.paginationTypes.get(this.paginationType) || 'standard';

    // If the paginationType is 'standard', do nothing
    if (method === 'standard') {
      return;
    }

    // Initialize the pagination using the given method
    this.initPagination(method);
  }

  // Initialize the pagination using the given method
  initPagination(method) {
    try {
      // Create an Ajaxinate object with the given method
      new Ajaxinate({
        container: '#product-grid',
        method,
        pagination: '.pagination-wrapper',
        loadingText: 'Loading more\u2026',
      });
    } catch (error) {
      // Handle any errors that may occur
      console.error(error);
    }
  }
}

export default ProductGrid;

customElements.define('product-grid', ProductGrid);
